import { splitTxtValue } from "./useHook";

const formatHeader = (headerArr: string[]) => {
  const result: any = {};
  const header = headerArr[0];
  result["dataDivision"] = header.substring(0, 1);
  result["typeCode"] = header.substring(1, 3);
  result["codeDivision"] = header.substring(3, 4);
  result["transferRequesterCode"] = header.substring(4, 14).replace(/^0+/, "");
  result["transferRequesterName"] = header.substring(14, 54).trim();
  result["startUpDate"] = header.substring(54, 58);
  result["destinationBankNumber"] = header.substring(58, 62).replace(/^0+/, "");
  result["destinationBankName"] = header.substring(62, 77).trim();
  result["destinationBranchNumber"] = header
    .substring(77, 80)
    .replace(/^0+/, "");
  result["destinationBranchName"] = header.substring(80, 95).trim();
  result["depositType"] = header.substring(95, 96);
  result["accountNumber"] = header.substring(96, 103).trim().padStart(7, "0");
  result["dummy"] = header.substring(103, 120).trim();
  return result;
};

const formatData = (recordArr: string[]) => {
  const result: any = {};
  const record = recordArr[0];
  result["dataDivision"] = record.substring(0, 1);
  // 銀行番号 ゼロサプレス 例外
  result["bankNumber"] = record.substring(1, 5).trim().padStart(4, "0");
  result["bankName"] = record.substring(5, 20).trim();
  // 支店番号 ゼロサプレス 例外
  result["branchNumber"] = record.substring(20, 23).padStart(3, "0");
  result["branchName"] = record.substring(23, 38).trim();
  result["billExchangeNumber"] = record.substring(38, 42);
  result["depositType"] = record.substring(42, 43);
  result["accountNumber"] = record.substring(43, 50).replace(/^0+/, "");
  result["recipientName"] = record.substring(50, 80).trim();
  result["transferAmount"] = record.substring(80, 90).replace(/^0+/, "");
  result["newCode"] = record.substring(90, 91);
  result["ediInformation"] = record.substring(91, 111).trim();
  result["transferDesignationType"] = record.substring(111, 112);
  result["identificationDisplay"] = record.substring(112, 113).trim();
  result["dummy"] = record.substring(113, 118).trim();
  result["dishonorReason"] = record.substring(118, 119);
  result["cancelType"] = record.substring(119, 120);

  return result;
};

const formatTrailer = (trailerArr: string[]) => {
  const result: any = {};
  const trailer = trailerArr[0];
  result["dataDivision"] = trailer.substring(0, 1);
  result["totalNumber"] = trailer.substring(1, 7).replace(/^0+/, "");
  result["totalAmount"] = trailer.substring(7, 19).replace(/^0+/, "");
  result["cancelTotalNumber"] = trailer.substring(19, 25).replace(/^0+/, "");
  result["cancelTotalAmount"] = trailer.substring(25, 37).replace(/^0+/, "");
  result["dummy"] = trailer.substring(37, 120).trim();
  return result;
};

const formatEnd = (endArr: string[]) => {
  const result: any = {};
  const end = endArr[0];
  result["dataDivision"] = end.substring(0, 1);
  result["dummy"] = end.substring(1, 120).trim();
  return result;
};

// フォーマット
const formatNonDeliverDetail = (txtValue: any) => {
  const result: any = {};
  const { header, data, trailer, end } = splitTxtValue(txtValue);

  result["header"] = formatHeader(header);
  result["data"] = data.map((record: any) => formatData(record));
  result["trailer"] = formatTrailer(trailer);
  result["end"] = formatEnd(end);

  return result;
};

export { formatNonDeliverDetail };
